import { render, staticRenderFns } from "./Vetters.vue?vue&type=template&id=57b38184&"
import script from "./Vetters.vue?vue&type=script&lang=js&"
export * from "./Vetters.vue?vue&type=script&lang=js&"
import style0 from "./Vetters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports